/**
 * Task DD: keyless Google Maps tools for the branch clock-in location (paste a link, open in Google Maps, embed
 * preview) and 分店管理 / Branch management (performance with filters, cash flow, staff per branch).
 * One row per key: [key, English, 中文]. Malay falls back to English.
 */
const ROWS = [
  // clock-in location: keyless Google Maps
  ["dd.map.link", "Paste Google Maps link", "粘贴 Google 地图链接"],
  ["dd.map.linkPh", "maps.app.goo.gl/… or 5.41640, 100.33270", "maps.app.goo.gl/… 或 5.41640, 100.33270"],
  ["dd.map.linkHint", "In Google Maps long-press the shop entrance to drop a pin, then Share → Copy link (or copy the coordinates shown).", "在 Google 地图里长按店门口放一个图钉，再点“分享 → 复制链接”（或复制显示的坐标）。"],
  ["dd.map.use", "Use link", "识别链接"],
  ["dd.map.resolving", "Reading the link…", "正在读取链接…"],
  ["dd.map.fromLink", "Pin set from the link ({lat}, {lng}).", "已按链接放置图钉（{lat}, {lng}）。"],
  ["dd.map.noCoords", "No coordinates found in that link. In Google Maps, long-press the shop to drop a pin and copy the numbers shown (e.g. 5.41640, 100.33270).", "链接中找不到坐标。请在 Google 地图中长按店铺放置图钉，然后复制显示的数字（例如 5.41640, 100.33270）。"],
  ["dd.map.notGoogle", "Paste a Google Maps link (maps.app.goo.gl, goo.gl/maps or google.com/maps) or coordinates \"lat, lng\".", "请粘贴 Google 地图链接（maps.app.goo.gl、goo.gl/maps 或 google.com/maps）或坐标“纬度, 经度”。"],
  ["dd.map.unreachable", "Couldn't open that link just now. Try again, or paste the coordinates.", "暂时无法打开该链接。请重试，或直接粘贴坐标。"],
  ["dd.map.open", "Open in Google Maps", "在 Google 地图打开"],
  ["dd.map.preview", "Google Maps preview of the pin", "图钉位置的 Google 地图预览"],
  ["dd.map.picked", "Pin moved to: {name}", "图钉已移到：{name}"],
  ["dd.map.search", "Search the shop", "搜索店铺"],
  ["dd.map.searchPh", "Type the shop name or address…", "输入店名或地址…"],
  ["dd.map.notFound", "Can't find it? Paste a Google Maps link", "找不到？贴上 Google 地图链接"],
  // 分店管理 / Branch management
  ["dd.br.preset.today", "Today", "今天"],
  ["dd.br.preset.yesterday", "Yesterday", "昨天"],
  ["dd.br.preset.this_week", "This week", "本周"],
  ["dd.br.preset.this_month", "This month", "本月"],
  ["dd.br.preset.last_month", "Last month", "上月"],
  ["dd.br.preset.last_30", "Last 30 days", "最近 30 天"],
  ["dd.br.preset.custom", "Custom", "自定义"],
  ["dd.br.period", "Period", "时间范围"],
  ["dd.br.from", "From", "开始"],
  ["dd.br.to", "To", "结束"],
  ["dd.br.branches", "Branches", "分店"],
  ["dd.br.allBranches", "All branches", "全部分店"],
  ["dd.br.compare", "Compare side by side", "并排对比"],
  ["dd.br.range", "{from} – {to}", "{from} 至 {to}"],
  ["dd.br.total", "All selected branches", "所选分店合计"],
  ["dd.br.sales", "Sales", "营业额"],
  ["dd.br.orders", "Orders", "订单数"],
  ["dd.br.avgTicket", "Average ticket", "客单价"],
  ["dd.br.refunds", "Refunds", "退款"],
  ["dd.br.services", "Services", "服务"],
  ["dd.br.products", "Products", "产品"],
  ["dd.br.packages", "Packages", "套餐"],
  ["dd.br.subscriptions", "Subscriptions", "订阅"],
  ["dd.br.other", "Top-ups & delivery", "充值与运费"],
  ["dd.br.newCustomers", "New customers", "新顾客"],
  ["dd.br.returning", "Returning customers", "回头客"],
  ["dd.br.walkIns", "Walk-in sales", "散客订单"],
  ["dd.br.trend", "Sales per day", "每日营业额"],
  ["dd.br.noData", "No sales in this period.", "此期间没有销售。"],
  ["dd.br.metric", "Metric", "指标"],
  ["dd.br.splitTitle", "Sales by type", "营业额构成"],
  ["dd.br.moreInfo", "Stock, team & cashier logins", "库存、团队与收银账号"],
  // cash flow
  ["dd.cf.title", "Cash flow per branch", "各分店现金流"],
  ["dd.cf.in", "Money in", "收入"],
  ["dd.cf.out", "Money out", "支出"],
  ["dd.cf.net", "Net cash flow", "净现金流"],
  ["dd.cf.m.cash", "Cash", "现金"],
  ["dd.cf.m.card", "Card", "刷卡"],
  ["dd.cf.m.ewallet", "E-wallet", "电子钱包"],
  ["dd.cf.m.transfer", "Bank transfer", "银行转账"],
  ["dd.cf.m.stripe", "Stripe online", "Stripe 在线支付"],
  ["dd.cf.m.stored_value", "Stored value used", "储值消费"],
  ["dd.cf.storedHint", "Paid from customers' stored value — no new money, not counted in money in.", "顾客使用储值支付 — 不是新收入，不计入收入。"],
  ["dd.cf.refunds", "Refunds", "退款"],
  ["dd.cf.payouts", "Stored value paid out", "储值退还"],
  ["dd.cf.expenses", "Expenses paid", "已付费用"],
  ["dd.cf.expensesUnpaid", "{amount} unpaid expenses dated in this period", "此期间另有 {amount} 未付费用"],
  ["dd.cf.headOffice", "Head-office expenses (no branch)", "总部费用（未分配分店）"],
  ["dd.cf.suppliers", "Supplier payments", "供应商付款"],
  ["dd.cf.drawer", "Cash drawer", "钱箱"],
  ["dd.cf.payIn", "Pay-ins", "存入"],
  ["dd.cf.payOut", "Pay-outs", "取出"],
  ["dd.cf.sessions", "{n} shifts · {closed} closed · {days} days closed", "{n} 个班次 · {closed} 个已结束营业 · {days} 天已日结"],
  ["dd.cf.difference", "Drawer difference", "钱箱差额"],
  ["dd.cf.diffDays", "Days with a difference", "有差额的营业日"],
  ["dd.cf.expected", "Expected", "应有"],
  ["dd.cf.counted", "Counted", "实点"],
  ["dd.cf.noDiff", "No drawer differences in this period.", "此期间钱箱没有差额。"],
  ["dd.cf.csv", "Export CSV", "导出 CSV"],
  // staff
  ["dd.st.title", "Staff per branch", "各分店员工数据"],
  ["dd.st.name", "Employee", "员工"],
  ["dd.st.branch", "Branch", "分店"],
  ["dd.st.serviceSales", "Service sales", "服务业绩"],
  ["dd.st.productSales", "Product sales", "产品业绩"],
  ["dd.st.sales", "Total sales", "总业绩"],
  ["dd.st.commission", "Commission", "提成"],
  ["dd.st.services", "Services", "服务次数"],
  ["dd.st.customers", "Customers served", "服务顾客"],
  ["dd.st.avgTicket", "Average ticket", "客单价"],
  ["dd.st.days", "Days worked", "出勤天数"],
  ["dd.st.hours", "Hours", "工时"],
  ["dd.st.sort", "Sort by", "排序"],
  ["dd.st.none", "No staff at these branches yet.", "这些分店还没有员工。"],
  ["dd.st.attOff", "Attendance (days / hours) needs the Full plan.", "出勤天数 / 工时需要完整版方案。"],
  ["dd.st.detail", "{name} · {branch}", "{name} · {branch}"],
  ["dd.st.allBranches", "all selected branches", "所选分店"],
  ["dd.st.perDay", "Per day", "每日"],
  ["dd.st.lines", "Sales lines", "业绩明细"],
  ["dd.st.shifts", "Shifts", "打卡记录"],
  ["dd.st.noLines", "No sales in this period.", "此期间没有业绩。"],
  ["dd.st.hm", "{h} h {m} min", "{h} 小时 {m} 分"],
  ["dd.st.open", "Still clocked in", "尚未下班"],
] as const;

export type DdKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<DdKey, string>;

export const taskDD = { en: col(1), zh: col(2), ms: col(1) };
